<script>
import Spinner from "@/components/ui/Spinner";
import configService from "@/services/config";
import { mapGetters } from "vuex";
import Indications from "./Indications";

export default {
  name: "IndicationForm",

  props: {
    forms: {
      type: Array,
      required: true,
    },
    savedIndications: {
      type: Array,
      required: true,
    },
    appointment: {
      type: Object,
    },
    patient: {
      type: Object,
    },
    existingEvolution: {
      type: Object,
      default: null,
    },
  },

  components: {
    Spinner,
    Indications,
  },

  data() {
    return {
      isLoading: false,
      s3Url: configService.s3Url,
      isIndicationModalVisible: false,
      selectedIndication: null,
      isContentHidden: this.isCollapsable,
      filterModalShowed: false,
      indicationsFilter: [],
      appointmentStatus: this.status,
      typesSelected: [],
    };
  },

  computed: {
    ...mapGetters(["user", "isPatient"]),
    evolutionPrefill() {
      if (!this.existingEvolution) return null;
      const ev = this.existingEvolution;
      return {
        _existingId: ev._id,
        // Las evoluciones viejas guardaron el motivo del desplegable en
        // `consultation`; lo precargamos en el campo de texto que quedo.
        publicConsultation: ev.publicConsultation || ev.consultation || "",
        diagnosis: ev.diagnosis?.id || "",
        publicDiagnosis: ev.publicDiagnosis || "",
        description: ev.description || "",
      };
    },
  },

  methods: {
    triggerUpload(createdIndication) {
      const refName = `indications-${createdIndication.type}`;
      this.$refs[refName][0].triggerUpload(createdIndication);
    },

    onDiagnosisSelected(diagnosis) {
      for (const form of this.forms) {
        const ref = this.$refs[`indications-${form.type}`];
        if (ref && ref[0]) {
          ref[0].applyExternalDiagnosis(diagnosis);
        }
      }
    },

    onPublicDiagnosisSelected(value) {
      for (const form of this.forms) {
        const ref = this.$refs[`indications-${form.type}`];
        if (ref && ref[0]) {
          ref[0].applyExternalPublicDiagnosis(value);
        }
      }
    },
  },
};
</script>

<template lang="pug">
.content
  indications(
    :ref="`indications-${form.type}`"
    v-for="(form, index) in forms"
    :savedIndications="savedIndications"
    :form="form"
    :appointment="appointment"
    :patient="patient"
    :prefillValues="form.type === 'evolution' ? evolutionPrefill : null"
    @diagnosis-selected="onDiagnosisSelected"
    @public-diagnosis-selected="onPublicDiagnosisSelected"
  )
</template>

<style lang="scss">
.form-box {
  .el-timeline-item {
    &:last-child {
      padding-bottom: 0;
    }

    &__timestamp {
      margin: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.header {
  position: sticky;
  top: 0;

  .buttons {
    display: flex;
  }
}

.expand {
  transition: all 0.4s ease-in-out;
  transform: rotate(180deg);
}

.rotate {
  transform: rotate(0deg);
}

.indication-box {
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  margin: 10px 0;
}

.indication-selected {
  background-color: #d5dbf366;
}

.indication-box-header {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 48px;

  h3 {
    margin: 0 15px;
    font-weight: 600;
  }
}

.check-box-true {
  width: 12px;
  height: 12px;
  background-color: $primary;
  border-radius: 2px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.45);
}

.check-box-false {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.45);
}

.content {
  visibility: visible;
  transition: all 0.4s ease-in-out;

  &.hide-content {
    visibility: hidden;
    overflow: hidden;
    max-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    transition: all 0.4s ease-in-out;
  }

  .box {
    flex-direction: column;
    margin: 0;
    align-items: flex-start;

    .micon {
      margin-left: 5px;
    }
  }
}

.selectAll {
  margin: 15px 0 10px;
}

.indications-options {
  display: flex;
}

.indication-option {
  border-color: $cuttysark;
  color: $cuttysark;
  padding: 0px 7px;
  transition: opacity 250ms;

  &:hover {
    opacity: 0.9;
  }
}

.selected {
  border-color: $primary;
  color: $primary;
  background: $primary;
  color: #ffffffff;

  &::after {
    content: "╳";
    font-size: 8px;
    margin-left: 6px;
    color: #ffffffff;
    font-weight: bold;
  }
}

.event-detail-modal {
  h2 {
    font-weight: bold;
    margin-bottom: 10px;
  }

  h3 {
    margin: 0 0 20px;
  }

  .order-by {
    margin-bottom: 25px;
  }

  .el-dialog__body {
    padding-top: 0;
  }

  .form-item {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    padding-right: 120px;

    .checkbox {
      margin-left: 15px;
    }

    .description {
      word-break: break-word;
      margin-bottom: 5px;
      font-size: 16px;
    }
  }
}
</style>
